module.exports = __webpack_public_path__ + "img/0cd1000d08c313eeafc18c543aea381.01dff5d0.jpg";